import React from 'react'
import css from './Event.module.css'
import cx from 'classnames'
import TrackIcon from '../icons/track'
import PageIcon from '../icons/page'

class Event extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      isOpen: false
    }
  }

  render () {
    const { title, subTitle, extra, type, children, className, ...props } = this.props
    const { isOpen } = this.state

    return (
      <div className={cx({
        [css.wrapper]: true,
        [className]: !!className
      })} {...props}>
        <div className={cx({
          [css.header]: true,
          [css.headerOpen]: isOpen
        })} onClick={() => this.setState({ isOpen: !isOpen })}>
          <div className={css.iconContainer}>
            {type === 'page' ? <PageIcon /> : <TrackIcon />}
          </div>
          <div className={css.content}>
            <span className={css.title}>{title}</span>
            <span className={css.subTitle}>{subTitle}</span>
          </div>
          {extra && (
            <div className={css.extra}>
              {extra}
            </div>
          )}
        </div>
        {isOpen && (
          <div className={css.body}>
            {children}
          </div>
        )}
      </div>
    )
  }
}

Event.displayName = 'Event'

export default Event



// WEBPACK FOOTER //
// ./components/Customers/presentational/Event.js